<template>
    <!-- <router-link class="cx_menu_item" :to="to">
      <i v-if="icon != null" class="material-icons md valign">{{ icon }}</i>{{ $translate(caption) }}
    </router-link> -->
    <Button2 class="cx_menu_button" :buttonStyle="style" @click="onClick" :caption="$translate(caption)" :tooltip="tooltip" :disabled="disabled">
        <SvgIcon :name="svg" v-if="svg" :width="vertical ?40 : 20" :height="vertical ?40:20"/>
        <span>{{caption}}</span>
        <span class="badge" :class="{'ok': count == 0}" v-if="count || count == 0">{{count}}</span>        
    </Button2>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GlobalMenuItem extends Vue {
  @Prop() public to!: string;
  @Prop() public caption!: string;
  @Prop() public icon?: string;
  @Prop({default:null}) public svg: string;
  @Prop({ default: null }) public perm: string;
  @Prop({default:true}) public vertical:boolean;
  @Prop({default:null}) public count:number;
  @Prop() public tooltip: string;
  @Prop({default:false}) public disabled: boolean;

  public onClick(){
      if(this.to) this.$router.push(this.to);
      this.$emit("click");      
  }
  public get style(){
      if (this.vertical) return {'display': 'flex', 'flex-direction': 'column' , 'justify-content': 'space-around', 'align-items': 'center'}
      return {'display': 'flex','justify-content': 'start','align-items': 'center'};
  }  
}
</script>
<style lang="scss">
    .cx_menu_item{
        padding:6px 20px;
        color:#212529 !important;     

        &:hover {
            color: #007bff !important;        
            cursor: pointer;      
            text-decoration:none !important;              
        }   



    }

    .cx_menu_button {
        width:140px;
        height:100px;
        // margin: 5px 5px;
        font-size:14px;
        position: relative;

        .cx_button {
            width:100%;
            height: 100%;
        }
        .badge{
            position: absolute;
            top : -7px;
            right : -7px;
            margin-left: 10px;
            font-size:12px;
            text-shadow: none;
            background-color: red;
            color:white;
            // border-radius: 10rem;
            border-radius: 8px;
            height: 16px;
            padding-top: 2px;
            &.ok {
            background-color: rgb(149, 190, 126);      
            }
        }
    }
</style>
